import { useQuery } from '@tanstack/react-query';
import { elowenClient } from '../../lib/elowenClient';
import { pluginLucideIcon } from '../../lib/pluginIcons';

/** One visual language for every plugin: its declared Lucide glyph in the same neutral frame. Package
 *  brand assets may still exist for external/marketplace use, but never make the in-app catalog noisy
 *  or unreadable on OLED themes. */
export function PluginIcon({ name, glyph, size = 24 }: { name?: string; glyph?: string; size?: number }) {
  return name && glyph === undefined ? <NamedPluginIcon name={name} size={size} /> : <PluginIconGlyph glyph={glyph} size={size} />;
}

/** Observe existing catalog entries only: names in a changelog are not authority to fetch admin data. */
function NamedPluginIcon({ name, size }: { name: string; size: number }) {
  const installed = useQuery({ queryKey: ['plugins'], queryFn: elowenClient.plugins, enabled: false });
  const marketplace = useQuery({ queryKey: ['marketplace'], queryFn: () => elowenClient.marketplace(), enabled: false });
  const glyph = installed.data?.find((plugin) => plugin.name === name)?.glyph
    ?? marketplace.data?.plugins.find((plugin) => plugin.name === name)?.glyph;
  return <PluginIconGlyph glyph={glyph} size={size} />;
}

function PluginIconGlyph({ glyph, size }: { glyph: string | undefined; size: number }) {
  const Icon = pluginLucideIcon(glyph);
  return (
    <span
      className="flex shrink-0 items-center justify-center rounded-md border border-border bg-muted text-muted-foreground"
      style={{ width: size, height: size }}
    >
      <Icon size={Math.round(size * 0.46)} aria-hidden />
    </span>
  );
}
